import { LogpointsLayer } from '@openlayers/logpoints/LogpointsLayer';
import { featuresExtent } from '@openlayers/ol-utils';
import { Events, EventsGlobal } from '@shared/Events';
import { LogpointsPanelGenericComponent } from '@shared/logpoints/ui/LogpointsPanelGenericComponent';
import { PageStateUtils } from '@shared/user-state/PageStateUtils';
import { observer } from 'mobx-react';
import * as React from 'react';
import { makeObservable, observable } from 'mobx';

const __ = kuura.getMessage;

@observer
export class LogpointsPanel2dMapComponent extends React.Component<{
    treeData: ITreeData;
    logpointsLayer: LogpointsLayer;
    showToolbar?: boolean;
    mobileView?: boolean;
    onFitVisible?: () => void;
    sidebarWidth?: number;
}> {
    genericComponent: LogpointsPanelGenericComponent | null;
    obsProps = null;

    constructor(props) {
        super(props);
        this.obsProps = observable(this.props);
        makeObservable(this);
    }

    componentDidMount() {
        this.props.logpointsLayer.layerSource.on('change', this.loadedLogpointsChanged);
    }

    componentWillUnmount() {
        this.props.logpointsLayer.layerSource.un('change', this.loadedLogpointsChanged);
    }

    loadedLogpointsChanged = () => {
        if (this.genericComponent) {
            this.genericComponent.loadedLogpointsChanged();
        }
    };

    render() {
        return (
            <LogpointsPanelGenericComponent
                ref={el => (this.genericComponent = el)}
                mobileView={this.props.mobileView}
                treeData={this.props.treeData}
                pinLeftOffset={this.props.sidebarWidth}
                loadFolder={id => this.props.logpointsLayer.fetchAndDrawFolder(id)}
                loadFile={id => this.props.logpointsLayer.fetchAndDrawFile(id)}
                loadLogpointsById={ids => this.props.logpointsLayer.fetchAndDrawMultiple(ids)}
                onFilterChanged={state => this.obsProps.logpointsLayer.applyFilter(state)}
                getAllLoadedLogpoints={() => this.obsProps.logpointsLayer.layerSource.getFeatures().map(f => f.get('data'))}
                zoomLogpointBySource={source => {
                    const logpoints = this.props.logpointsLayer.getFeaturesBySource(source).filter(l => !l.get('hidden'));
                    const extent = featuresExtent(logpoints);
                    Events.trigger(EventsGlobal.MAP_FIT_EXTENT, { extent });
                }}
                clearAllLogpointFromMap={() => {
                    this.props.logpointsLayer.clear();
                }}
                clearLogpointFromMapBySource={source => {
                    this.props.logpointsLayer.removeFeaturesBySource(source, false);
                }}
                getDisplaySettings={() => {
                    return {
                        iconScale: this.props.logpointsLayer.iconScale,
                        iconLabelProp: this.props.logpointsLayer.labelProps,
                        noNamesInLabel: this.props.logpointsLayer.noNamesInLabel,
                        showLines: this.props.logpointsLayer.showLines,
                        colorFunction: this.props.logpointsLayer.colorFunctionName,
                    };
                }}
                restoreDisplaySettings={settings => {
                    if (PageStateUtils.stateHasKey<IMapPageStateLogpointsPanel>(settings, 'iconScale')) {
                        this.props.logpointsLayer.setIconScale(settings.iconScale);
                    }
                    if (PageStateUtils.stateHasKey<IMapPageStateLogpointsPanel>(settings, 'iconLabelProp')) {
                        this.props.logpointsLayer.setLabelProps(settings.iconLabelProp);
                    }
                    if (PageStateUtils.stateHasKey<IMapPageStateLogpointsPanel>(settings, 'noNamesInLabel')) {
                        this.props.logpointsLayer.setNoNamesInLabels(settings.noNamesInLabel);
                    }
                    if (PageStateUtils.stateHasKey<IMapPageStateLogpointsPanel>(settings, 'showLines')) {
                        this.props.logpointsLayer.setShowLines(settings.showLines);
                    }
                    if (PageStateUtils.stateHasKey<IMapPageStateLogpointsPanel>(settings, 'colorFunction')) {
                        this.props.logpointsLayer.setColorFunction(settings.colorFunction);
                    }
                }}
            />
        );
    }
}
